module.exports = __webpack_public_path__ + "img/programa-pdf.5e63aa2d.png";